import type { SketchEntityReferenceTopologyOwnerQueryInput } from '../../repository/SketchEntityReferenceRepository';

/**
 * 转换实体引用 topology owner 重建查询策略。
 *
 * 设计说明：
 * 1. 特征结果体回灌属于“刷新当前拓扑代理”的场景，目标是把同一特征下的旧引用捞出来重新投影；
 * 2. 特征编辑后 bodyBindingId 可能新增、消失或变化，如果继续按新 body 精确查询，会漏掉旧记录；
 * 3. 删除清理不走本策略，仍由删除协调器保持 bodyBindingId 精确匹配，避免误删其他 body 的引用。
 */
export class SketchEntityReferenceTopologyRebuildOwnerPolicy {
	/**
	 * 规范化特征结果体回灌后的重建 owner 查询。
	 *
	 * @param owner Viewer 从当前结果体解析出的 topology owner。
	 * @returns 用于重建刷新的 owner 查询输入。
	 */
	public static normalizeFeatureResultFeedbackOwner(
		owner: SketchEntityReferenceTopologyOwnerQueryInput,
	): SketchEntityReferenceTopologyOwnerQueryInput {
		if (owner.ownerKind !== 'feature-result') {
			return owner;
		}

		return {
			ownerKind: owner.ownerKind,
			ownerId: owner.ownerId,
			matchAnyBodyBinding: true,
		};
	}
}
